import { Component, OnInit } from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {OutlayService} from '../../services/outlay.service';
import {MessagingService} from '../../../../../core/service/messaging.service';
import {VnaPortalSelected} from '../../../../../core/data/messaging/VnaPortalSelected';
import {AuthService} from '../../../../../core/service/auth.service';
import {LocalDataSource} from 'ng2-smart-table';
import {DatesParserService} from '../../../../../core/service/dates_parser.service';
import {Angular2Csv} from 'angular2-csv';

import * as _ from 'underscore';
import * as moment from 'moment';

@Component({
  selector: 'app-outlay-evolution',
  templateUrl: './outlay-evolution.component.html',
  styleUrls: ['./outlay-evolution.component.scss'],
})
export class OutlayEvolutionComponent implements OnInit {

    formSearch: FormGroup;
    submitted: boolean = false;
    evolution: Object = {};
    barChartType: string = 'bar';

    settings: Object;
    chartOptions: Object = {};
    enabled: boolean = false;
    perPage:any=15;
    dataS:LocalDataSource;

    constructor(private outlayManager: OutlayService, private auth: AuthService, private messaging: MessagingService, private datesParser: DatesParserService) {
        this.formSearch = new FormGroup(
            {
                'start_date' : new FormControl('', Validators.required),
                'end_date' : new FormControl('', Validators.required),
                'alias_verification' : new FormControl('', Validators.required),
                'all_verification_camps' : new FormControl('0'),
                'campaign' : new FormControl(''),
                'lang' : new FormControl(''),
                'group_type' : new FormControl('daily')
            }
        );

        this.settings = {
            columns: {
                key: {title: 'Day'},
                cpm: {title: 'Cpm'},
                day_outlay: {title: 'Day Outlay'},
                calls: {title: 'Calls'},
            },
            attr: {
                class: 'table table-bordered'
            },
            actions: {
                add: false,
                delete: false,
                edit: false
            },
            pager:{
                perPage:this.perPage
            }
        };

        this.submitted = false;
        this.dataS=new LocalDataSource();
    }

    ngOnInit() {
        this.messaging.message.subscribe(
            (msg: any) => {
                if(msg instanceof VnaPortalSelected && !msg.isTheFirst()){
                    this.dataS.reset();
                    this.dataS.empty();
                    this.evolution = {};
                }
            }
        )
    }

    findOutlayEvolution() {

        if(!this.formSearch.valid){
            this.submitted = true;
            return;
        }

        this.evolution = {};
        this.enabled = true;
        let pkService = this.formSearch.value.alias_verification;
        let form = Object.assign({}, this.formSearch.value);
        form = this.datesParser.cleanDates(form, ['start_date', 'end_date'], false);

        if(_.isArray(form['campaign'])){
            form['campaign'] = _.reduce(form['campaign'], (memo, element) => {
                return (memo.length == 0) ? element['pk'] : memo + ',' + element['pk'];
            }, "")
        }

        delete form['alias_verification'];

        this
            .outlayManager
            .findOutlayEvolution(this.auth.getPkPortal(), pkService, form)
            .subscribe(
                result => {

                    this.evolution = result;
                    let max = parseFloat(this.evolution['portal']['max']) + 0.5;
                    this.chartOptions['responsive'] = true;
                    this.chartOptions['scales'] = { 'yAxes' : [{'ticks' : { 'beginAtZero' : true, 'suggestedMax' : max} }] };
                    let chartData: Array<any> = [];
                    this.evolution['portal']['values'].forEach( (value) => {
                        chartData.push({'data' : value, 'label' : this.evolution['portal']['series'][0]});
                    });

                    this.evolution['portal']['values'] = chartData;
                    this.dataS.load(this.evolution['portal']['rowed_data']);

                    this.enabled = false;
                }
            )
    }

    refresh(){
        this.dataS.setPaging(1,this.perPage,true);
    }

    evolutionToCsv(): void {
        this.dataS.getAll().then(
            (result) => {
                let headers = _.keys(this.settings['columns']);
                new Angular2Csv(result, 'outlay_evolution_report_' + moment().unix(), {
                    'showLabels' : true,
                    'headers' : headers
                });
            }
        );
    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/analytics/outlay/components/outlay-evolution/outlay-evolution.component.ts